import * as React from "react";

const CareContinuum = () => {
  return (
    <ol className="references">
    <li>
      Centers for Disease Control and Prevention. Understanding the HIV care continuum. July 2019. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/pdf/library/factsheets/cdc-hiv-care-continuum.pdf">https://www.cdc.gov/hiv/pdf/library/factsheets/cdc-hiv-care-continuum.pdf</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. About HIV. Reviewed June 30, 2022. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/basics/whatishiv.html">https://www.cdc.gov/hiv/basics/whatishiv.html</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Newly diagnosed with HIV. Reviewed July 15, 2022. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/basics/livingwithhiv/newly-diagnosed.html">https://www.cdc.gov/hiv/basics/livingwithhiv/newly-diagnosed.html</a>
    </li>
    <li>
      HIV.gov. HIV care continuum. Updated October 28, 2022. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.hiv.gov/federal-response/policies-issues/hiv-aids-care-continuum">https://www.hiv.gov/federal-response/policies-issues/hiv-aids-care-continuum</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Monitoring selected national HIV prevention and care objectives by using surveillance data—United States and 6 
      dependent areas, 2019. <em>HIV Surveillance Supplemental Report</em>. 2021;26(2). Published May 2021. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-vol-26-no-2.pdf">https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-vol-26-no-2.pdf</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Understanding care. Reviewed May 20, 2021. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/basics/livingwithhiv/understanding-care.html">https://www.cdc.gov/hiv/basics/livingwithhiv/understanding-care.html</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. HIV treatment. Reviewed November 21, 2023. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html">https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. HIV declines among young people and drives overall decrease in new HIV infections. Updated May 23, 2023. Accessed February 8, 2024.&nbsp;
      <br class="d-lg-none" />
      <a target="_blank" href="https://www.cdc.gov/nchhstp/newsroom/2023/2021-hiv-incidence.html">https://www.cdc.gov/nchhstp/newsroom/2023/2021-hiv-incidence.html</a>
    </li>
    <li>
      McNairy ML, El-Sadr WM. A paradigm shift: focus on the HIV prevention continuum. <em>Clin Infect Dis</em>. 2014;59(Suppl 1):S12-S15.
    </li>
    <li>
      Centers for Disease Control and Prevention. National HIV/AIDS Strategy for the United States 2022-2025. Reviewed October 27, 2022. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://npin.cdc.gov/publication/national-hivaids-strategy-united-states-2022-2025">https://npin.cdc.gov/publication/national-hivaids-strategy-united-states-2022-2025</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. About Ending the HIV Epidemic in the U.S. Initiative. Reviewed September 7, 2021. Accessed May 7, 2024. &nbsp; 
      <br className="d-block d-md-none" />
      <a target="_blank" href="https://www.cdc.gov/endhiv/about.html">https://www.cdc.gov/endhiv/about.html</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Condom Distribution Structural Intervention (CDSI). Reviewed April 25, 2023. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/effective-interventions/prevent/condom-distribution-programs/index.html">https://www.cdc.gov/hiv/effective-interventions/prevent/condom-distribution-programs/index.html</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Injection drug use. Reviewed March 16, 2022. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/risk/drugs/index.html">https://www.cdc.gov/hiv/risk/drugs/index.html</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Prevention. Reviewed February 7, 2024. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/stophivtogether/hiv-prevention/index.html">https://www.cdc.gov/stophivtogether/hiv-prevention/index.html</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Materials for your practice and patients. Reviewed June 14, 2022. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/clinicians/materials/index.html">https://www.cdc.gov/hiv/clinicians/materials/index.html</a>
    </li>
    <li>
      National Institute of Allergy and Infectious Diseases. Pre-exposure prophylaxis (PrEP) to prevent HIV. Reviewed  March 1, 2024. Accessed May 7, 2024.&nbsp;
      <br class="d-lg-none" />
      <a target="_blank" href="https://www.niaid.nih.gov/diseases-conditions/pre-exposure-prophylaxis-prep#">https://www.niaid.nih.gov/diseases-conditions/pre-exposure-prophylaxis-prep#</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Evidence of HIV treatment and viral suppression in preventing the 
      sexual transmission of HIV. Reviewed June 2, 2022. Accessed May 7, 2024. &nbsp; 
      <br className="d-block d-md-none"/>
      <a target="_blank" href="https://www.cdc.gov/hiv/risk/art/evidence-of-hiv-treatment.html">https://www.cdc.gov/hiv/risk/art/evidence-of-hiv-treatment.html</a>
    </li>
    <li>
      Centers for Disease Control and Prevention. Pre-exposure prophylaxis (PrEP). Reviewed July 5, 2022. Accessed May 7, 2024.  
      <br className="d-block d-md-none"/> 
      &nbsp;<a target="_blank" href="https://www.cdc.gov/hiv/risk/prep/index.html ">https://www.cdc.gov/hiv/risk/prep/index.html </a>
    </li>
    <li>
      National Institute of Allergy and Infectious Diseases. HIV undetectable=untransmittable (U=U), or treatment as prevention. Reviewed May 21, 2019. Accessed May 7, 2024.  
      <br className="d-block d-md-none"/>
      &nbsp;<a target="_blank" href="https://www.niaid.nih.gov/diseases-conditions/treatment-prevention">https://www.niaid.nih.gov/diseases-conditions/treatment-prevention</a>
    </li>
    <li>
      New York City Department of Health and Mental Hygiene. The New York City HIV status neutral prevention and treatment cycle. Accessed May 7, 2024.  
      <br className="d-block d-md-none"/>
      &nbsp;<a target="_blank" href="https://www1.nyc.gov/site/doh/health/health-topics/hiv-status-neutral-prevention-and-treatment-cycle.page">https://www1.nyc.gov/site/doh/health/health-topics/hiv-status-neutral-prevention-and-treatment-cycle.page</a>
    </li>
    <li>
      Myers JE, Braunstein SL, Xia Q, et al. Redefining prevention and care: a status-neutral approach to HIV. <em>Open Forum Infect Dis.</em> 2018;5(6):ofy097.
    </li>
    <li>
      Centers for Disease Control and Prevention. Getting tested. Reviewed April 9, 2021. Accessed May 7, 2024. 
      <br />
      <a target="_blank" href="https://www.cdc.gov/hiv/basics/hiv-testing/getting-tested.html">https://www.cdc.gov/hiv/basics/hiv-testing/getting-tested.html</a>
    </li>
    <li>
      Kay ES, Batey DS, Mugavero MJ. The HIV treatment cascade and care continuum: updates, goals, and recommendations for the future. <em>AIDS Res Ther</em>. 2016;13:35. 
    </li>
    </ol>
  )
  }

export default CareContinuum;